export const FORMULARIO_PROYECTO = 'FORMULARIO_PROYECTO';
export const OBTENER_PROYECTOS = 'OBTENER_PROYECTOS';
export const AGREGAR_PROYECTO = 'AGREGAR_PROYECTO';
export const VALIDAR_FORMULARIO = 'VALIDAR_FORMULARIO';
export const PROYECTO_ACTUAL = 'PROYECTO_ACTUAL';
export const ELIMINAR_PROYECTO = 'ELIMINAR_PROYECTO';
export const PROYECTO_ERROR = 'PROYECTO_ERROR';
export const PROYECTO_SALIR = 'PROYECTO_SALIR';

export const OBTENER_CONSUMOS = 'OBTENER_CONSUMOS';
export const OBTENER_CONSUMOSPYT = 'OBTENER_CONSUMOSPYT';
export const AGREGAR_CONSUMO = 'AGREGAR_CONSUMO';
export const OBTENER_CONSUMO_ED = 'OBTENER_CONSUMO_ED';
export const EDITAR_CONSUMO = 'EDITAR_CONSUMO';
export const ELIMINAR_CONSUMO  = 'ELIMINAR_CONSUMO';

export const XTAREAS_PROYECTO = 'XTAREAS_PROYECTO';
export const AGREGAR_XTAREA = 'AGREGAR_XTAREA';
export const VALIDAR_XTAREA = 'VALIDAR_XTAREA';
export const ELIMINAR_XTAREA = 'ELIMINAR_XTAREA';
export const ESTADO_XTAREA = 'ESTADO_XTAREA';
export const XTAREA_ACTUAL = 'XTAREA_ACTUAL';
export const ACTUALIZAR_XTAREA = 'ACTUALIZAR_XTAREA';
export const LIMPIAR_XTAREA = 'LIMPIAR_XTAREA';

export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';

export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';